export const convertStringToDate = (unknownDate: string | Date): Date => {
  if (!unknownDate) {
    return null;
  }

  try {
    if(typeof unknownDate === "string") {
      const [year, month, day] = unknownDate.split("T")[0].split("-").map(Number);
      return new Date(year, month - 1, day);
    } else {
      return unknownDate;
    }
  } catch {
    return null;
  }
};

export const toISOLocal = (d) => {
  if (d.length === 10) {
    return d;
  }
  const z = (n) => `0${n}`.slice(-2);

  return `${d.getFullYear()}-${z(d.getMonth() + 1)}-${z(d.getDate())}`;
};

export const dateFormat = (date) => {
  if (!date) {
    return null;
  }
  try {
    return typeof date === "string" ? date : toISOLocal(date);
  } catch {
    return null;
  }
};

export const inputDateFormat = (unknownDate) => {
  if (!unknownDate) {
    return null;
  }
  try {
    const d =
      typeof unknownDate === "string" ? new Date(unknownDate) : unknownDate;
    return toISOLocal(d);
  } catch {
    return null;
  }
};

export const dateAsWords = (unknownDate: string | Date) => {
  try {
    const d = convertStringToDate(unknownDate);
    if (!d) {
      return null;
    }
    return d.toLocaleDateString(undefined, {
      dateStyle: "long",
    });
  } catch {
    return null;
  }
};

export const isBeginningOfYear = (date) => {
  const guess = new Date(`${date} 00:00:00`);
  return guess.getMonth() === 0 && guess.getDate() === 1;
};

export const secondsToHours = (seconds: number) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds - hours * 3600) / 60);

  return hours > 0 ? `${hours}h, ${minutes}m` : `${minutes}m`;
};
